"use client";
import { Components } from "@mui/material";
import { Theme } from "@mui/material/styles";
import { muiInputLabelStyles } from "./muiInputLabel.styles";

type MuiInputLabelABStyleOverrides = Components<Theme>["MuiInputLabel"];

export const muiInputLabelABStyles: MuiInputLabelABStyleOverrides = {
  ...muiInputLabelStyles?.styleOverrides,
  styleOverrides: {
    root: ({ theme }) => ({
      color: theme.palette.primary.main,
      "&.Mui-focused": {
        color: theme.palette.primary.main,
      },
      "&.Mui-error.Mui-focused": {
        color: theme.palette.error.main,
      },
      "&.Mui-disabled": {
        color: theme.palette.neutral.main,
      },
    }),
  },
};
